/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import SubsectionRedesign from 'bundles/unified-description-page-common/components/shared/SubsectionRedesign';
import { useXDPRedesignPhase2Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase2Provider';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  spacing?: number;
};

const styles = {
  subsection: (spacing?: number) => css`
    padding: ${spacing ? `${spacing}px` : 'var(--cds-spacing-200)'} 0 var(--cds-spacing-200);
  `,
  subsectionTitle: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const Subsection = ({ title, children, spacing }: Props) => {
  const { treatment } = useXDPRedesignPhase2Data();
  const enableXDPRedesignVariantC = treatment === 'C';

  if (enableXDPRedesignVariantC) {
    return <SubsectionRedesign title={title}>{children}</SubsectionRedesign>;
  }

  return (
    <div css={styles.subsection(spacing)}>
      {title && <div css={styles.subsectionTitle}>{title}</div>}
      {children}
    </div>
  );
};

export default Subsection;
